export const ItemTypes = {
    BLOCK: 'BLOCK'
}
